export enum ProductTypes {
  PRODUCT = 'PRODUCT',
  E_VOUCHER = 'E_VOUCHER',
  GIFT_CARD = 'GIFT_CARD',
  CUSTOM_GIFT_CARD = 'CUSTOM_GIFT_CARD',
  PAPER_VOUCHER = 'PAPER_VOUCHER',
  CUSTOM_PAPER_VOUCHER = 'CUSTOM_PAPER_VOUCHER',
}

export enum ProductVideoModeTypes {
  INSPIRATIONAL = 'INSPIRATIONAL',
  CARROUSEL = 'CARROUSEL',
}

export enum ProductLinkType {
  ALT = 'ALT',
  STL = 'STL',
}

export enum ProductExcluded {
  CC_EXCLUDED = 'CC Excluded',
  CC_NOT_EXCLUDED = 'CC Not Excluded',
  HD_EXCLUDED = 'HD Excluded',
  HD_NOT_EXCLUDED = 'HD Not Excluded',
  SS_EXCLUDED = 'SS Excluded',
  SS_NOT_EXCLUDED = 'SS Not Excluded',
}

export enum ProductImageSizesPortraitEnum {
  thumb = '65x98',
  bundles = '109x164',
  basket = '180x279',
  lister = '316x474',
  detail = '550x825',
  zoom = '989x1484',
}

export enum NotifyMeError {
  SELECT_SIZE = 'NOTIFY_ME_SELECT_SIZE',
}

export enum ProductSpecialtyType {
    WINTERSPORT = 'WINTERSPORT',
}
